import React from 'react';
import t from 'prop-types';
import Draggable from 'react-draggable';

var BotonHerramientas = function BotonHerramientas(_ref) {
  var onClick = _ref.onClick;
  return React.createElement(Draggable, {
    axis: 'y',
    bounds: 'body',
    handle: '.deslizadorBotonBarraHerramientas'
  }, React.createElement('div', {
    className: 'fondoBotonBarraHerramientas'
  }, React.createElement('div', {
    className: 'deslizadorBotonBarraHerramientas'
  }), React.createElement('div', {
    className: 'botonBarraHerramientas',
    onClick: onClick
  })));
};

BotonHerramientas.propTypes = process.env.NODE_ENV !== "production" ? {
  onClick: t.func
} : {};
export default BotonHerramientas;